import axiosInstance from "../../../utils/axios";
import { objToURL } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/reports";

export const List = async (values) => {
    return await axiosInstance(options).get(`${path}/team-report${objToURL(values)}`);
}



